import React from 'react'; 
import PropTypes from 'prop-types';

const SubmitNotes = ({ lookup }) => {
    if (!lookup || !lookup.submitNotes) return null;
    return (
        <p>{lookup.submitNotes}</p>
    );
};

SubmitNotes.propTypes = {
    lookup: PropTypes.object.isRequired
};

export default SubmitNotes; 